import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import lookupActions from '../../../../actions/lookup.actions';
import mobileConfigActions from '../../../../actions/mobileConfig.actions';
import helper from '../../../../utils/helper';
import DeleteRecord from '../../../UI/DeleteRecord';
import MobileConfigurationsPage from './MobileConfigurationsPage';
import { useHistory } from 'react-router';

function MobileConfigurations({ mobileConfig, ...props }) {
  const history = useHistory();
  const { deptId } = helper.parseQueryString(props.location.search);
  const [configList, updateConfigList] = React.useState(null);
  const [state, setState] = React.useState({
    openModal: false,
    selectedRow: null,
  });
  const roleNames =
    JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
  const isAdmin = roleNames.includes('admin') || roleNames.includes('Admin');
  const userId = JSON.parse(localStorage.getItem('userProfile')).id;
  React.useEffect(() => {
    props.lookupActions.getDepartments();
  }, []);
  const columns = [
    { dataField: 'name', text: 'Name', sort: true },
    { dataField: 'alertsOnly', text: 'Alerts Only?', sort: true },
    { dataField: 'scrollTopMin', text: 'Scroll To Top (Min)', sort: true },
    {
      dataField: 'accessibleTypes',
      text: 'Accesibility',
      sort: true,
      formatter: (cell) => (cell ? 'Public' : 'Private'),
    },
    { dataField: 'userName', text: 'Owner', sort: true },
  ];
  const defaultSorted = [
    {
      dataField: 'name',
      order: 'asc',
    },
  ];
  const ctxMenuOptions = [
    [
      {
        name: 'Edit mobile configuration',
        action: (row, rowIndex) => {
          props.history.push(
            `/configure/mobile-configurations/edit-mobile-configuration?id=${row.id}`,
          );
        },
        className: (row) => isDisabled(row),
      },
      {
        name: 'Configure sensors',
        action: (row, rowIndex) => {
          props.history.push(
            `/configure/mobile-configurations/config-sensors?id=${row.id}`,
          );
        },
        className: (row) => isDisabled(row),
      },
      {
        name: 'Copy mobile configuration',
        action: (row, rowIndex) => {
          props.history.push(
            `/configure/mobile-configurations/copy-mobile-configuration?id=${row.id}&deptId=${deptId}`,
          );
        },
      },
      {
        name: 'Delete mobile configuration',
        action: (row, rowIndex) => {
          setState({ openModal: true, selectedRow: row });
        },
        className: (row) => isDisabled(row),
      },
    ],
  ];
  function isDisabled(row) {
    if (!isAdmin && row && row.userId !== userId) {
      return 'item-disable';
    }
  }
  function onCancel() {
    setState({ openModal: false, selectedRow: null });
  }
  async function onDelete() {
    setState({ ...state, openModal: false });
    await props.mobileConfigActions
      .deleteMobileConfig(state.selectedRow.id)
      .then(() =>
        props.mobileConfigActions
          .getMobileConfigsByDeptId(deptId)
          .then((resp) => updateConfigList(resp))
          .catch((error) => console.log(error)),
      );
  }
  React.useEffect(() => {
    const _deptId = helper.getUserDepartment(props.lookup.departments).deptId;
    history.replace(
      `/configure/mobile-configurations?deptId=${deptId ? deptId : _deptId}`,
    );
  }, [props.lookup.departments.length]);
  React.useEffect(() => {
    if (deptId !== undefined) {
      props.mobileConfigActions
        .getMobileConfigsByDeptId(deptId)
        .then((resp) => updateConfigList(resp))
        .catch((error) => console.log(error));
    }
  }, [deptId]);
  return (
    <>
      <DeleteRecord
        isOpen={state.openModal}
        title="Delete mobile configuration"
        body="Are you sure you want to delete this mobile configuration?"
        onCancel={onCancel}
        onConfirm={onDelete}
      />
      <MobileConfigurationsPage
        departments={props.lookup.departments}
        deptId={deptId}
        onChangeDept={(_deptId) =>
          history.replace(`/configure/mobile-configurations?deptId=${_deptId}`)
        }
        mobileConfigs={configList}
        columns={columns}
        defaultSorted={defaultSorted}
        ctxMenuOptions={ctxMenuOptions}
        loading={mobileConfig.loading}
        errors={mobileConfig.errors}
      />
    </>
  );
}

function mapStateToProps(state) {
  return {
    mobileConfig: state.mobileConfig,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    mobileConfigActions: bindActionCreators(
      Object.assign({}, mobileConfigActions),
      dispatch,
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MobileConfigurations);
